<style scoped lang="scss">
form {
    h2 {
        color: #000;
    }
    ::v-deep(.formkit-select-icon) {
        height: 50px;
        margin: 0;
        padding: 0;
    }
}
main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
}
</style>

<template>
    <div class="mb-5">
        <h1 class="page-title">{{ title }}</h1>
    </div>
    <div class="max-w-screen-xl mx-auto">
        <div class="flex flex-wrap -mx-4">
        <div class="w-full lg:w-1/4 px-3">
            <div class="mb-5">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Web*</h5>
                    <UploadImage :image-preview-url="getBaseUrl() + '/media/blank2.png'"
                         @image-removed="onImageWebRemoved"
                         @imageUploaded="onImageWebUpload"
                         @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
            <div class="mb-5">
            <div class="card w-75 shadow-xl">
                <div class="card-body items-center text-center">
                    <h5 class="card-title">Image Mobile*</h5>
                    <UploadImage :image-preview-url="getBaseUrl() + '/media/blank2.png'"
                         @image-removed="onImageMobileRemoved"
                         @imageUploaded="onImageMobileUpload"
                         @error="onImageUploadError"
                    />
                </div>
            </div>
            </div>
        </div>

        <div class="w-full lg:w-3/4 px-4">
        <div class="card w-full shadow-xl">
        <div class="card-body">
            <div class="w-full">
                <FormKit type="form"
                 :actions="false"
                 @submit="onSubmit"
                 #default="{ state: { valid } }"
                 outer-class="w-full"
                 incomplete-message="Veuillez remplir tous les champs correctement"
                >

                <FormKit type="text"
                 name="product"
                 label="Produit uuid *"
                 validation="required"
                 :validation-messages="{
                    required: 'Ce champ est obligatoire.'
                }"
                />
                <FormKit type="number"
                 name="position"
                 label="Position *"
                 validation="required|min:1"
                 :validation-messages="{
                    required: 'Ce champ est obligatoire.',
                    min: 'Ce champ doit être un nombre décimal superieur à 0',
                }"
                />
                <div class="card-actions">
                    <div v-if="loading === false">
                        <FormKit type="submit"
                         :label="submitBtnLabel"
                         :disabled="!valid"
                         :class="{ 'btn-primary': true, 'btn-block': true }"
                        />
                    </div>
                    <FormKit type="button"
                     label="Annuler"
                     @click="onCancel"
                     :class="{ 'btn-secondary': true, 'btn-block': true }"
                    />
                    </div>
                </FormKit>
            </div>
        </div>
        </div>
        </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {INews} from "@/models/homepage/INews";
const title = ref<string>("Ajouter une nouveauté");
const submitBtnLabel = 'Ajouter';
const router = useRouter();
const loading = ref<boolean>(false);

const form = ref<INews>({
    position: null,
    imageWeb: null,
    imageMobile: null,
    product: null
});

const onSubmit = async (formData) => {
    try {
        if (null === form.value.imageWeb || null === form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }
        const payload = {
            position: parseInt(formData.position),
            product: `/api/master-product/${formData.product}`,
            imageWeb: `/api/images/${form.value.imageWeb.uuid}`,
            imageMobile: `/api/images/${form.value.imageMobile.uuid}`
        }
        swal.confirm(`Êtes-vous sûr de vouloir ajouter ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && addNews(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const addNews = (data) => {
    ApiService.post('news', data)
        .then(() => {
            loading.value = false;
            swal.info("Ajout avec succès")
                .then((result) => {
                    if (result.isConfirmed) {
                        router.push({
                            name: "newsList"
                        });
                    }
                });
        }).catch((axiosError) => {
            swal.error("Une erreur est survenue au moment de l'ajout");
            axiosError.response.data.errors.forEach((error) => {
            if (error.message.startsWith("Item not found for")
                || error.message.startsWith("Could not convert database value")) {
                swal.error("Une erreur est survenue au moment de l'ajout, l’uuid ajoutée n’existe pas.");
                return false;

            }
        });
    });
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'ajout ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.push({
                name: "newsList"
            });
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}
</script>